// removed by extract-text-webpack-plugin
module.exports = {"root":"Body__root___2IlCU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/Body/Body.scss
// module id = 1017
// module chunks = 0